<template>
  <div class="medical-record-default-item">
    <div v-if="item?.tag?.id">
      <strong>Tag: </strong>{{ item.tag.name }}
      <div class="divider" />
    </div>

    <medical-record-measures class="mb-2" :items="measures" />

    <template v-for="(value, name) in item.anamnesis.inputs">
      <st-data-display :label="getInputLabel(name)" v-if="value" :key="name">
        <div class="text-pre" v-html="sanitizeHTML(value)" />
      </st-data-display>
    </template>

    <st-data-display label="CID" v-if="hasCIDs">
      <div v-for="(item, idx) in item.cids" :key="idx">
        <strong class="item-label">{{ item.code }}</strong>
        <small>-</small>
        <span class="ml-1">{{ item.name }}</span>
      </div>
    </st-data-display>
  </div>
</template>

<script>
import { sanitize as sanitizeHTML } from '@/helpers/html';
import * as measures from 'src/data/medical-record-measures';
import MedicalRecordMeasures from '../Measures.vue';

export default {
  components: {
    MedicalRecordMeasures,
  },
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      sanitizeHTML,
    };
  },
  computed: {
    measures() {
      return measures.filled([
        ...measures.anthropometry(this.item.anthropometry),
        ...measures.vitalSigns(this.item.vitalSigns),
      ]);
    },
    hasCIDs() {
      return Array.isArray(this.item.cids) && this.item.cids.length > 0;
    },
  },
  methods: {
    getInputLabel(name) {
      const labels = {
        subjective: 'Subjetivo',
        objective: 'Objetivo',
        assessment: 'Avaliação',
        plan: 'Plano',
        content: 'Anamneses / evolução',
      };
      return labels[name] || '';
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.medical-record-default-item {
  .item-label {
    color: $dark-blue-color-500;
    font-weight: 600;
    margin-right: $layout-spacing-sm;
  }
}
</style>
